import React from "react";
import { Modal } from 'antd';
import { forbidden_chars, LEAVE_PAGE } from "@/constants/constant.string";

const { confirm } = Modal;

export const sortObject = (obj) => {
    return Object.keys(obj).sort().reduce(function (result, key) {
        result[key] = obj[key] ? obj[key] : undefined;
        return result;
    }, {});
}

export const removeDublicates = (names) => {
    let unique = {};
    names.forEach(i => {
        if (!unique[i]) {
            unique[i] = true;
        }
    });
    return Object.keys(unique);
}

export const containForbiddenChars = (string) => {
    if (!string) {
        return false;
    }

    for (let position in forbidden_chars) {
        if (string.indexOf(forbidden_chars[position]) != -1) {
            return true;
        }
    }

    return false;
}

export const containForbiddenCharsInCustomList = (chars, string) => {
    if (!string)
        return false;
    for (let position in chars) {
        if (string.indexOf(chars[position]) != -1) {
            return true;
        }
    }

    return false;
}

export const closePanel = (oldData, newData, hidePanel) => {
    if (JSON.stringify(sortObject(oldData)) != JSON.stringify(sortObject(newData))) {

        confirm({
            title: LEAVE_PAGE,
            icon: <i className="ri-close-line"></i>,
            className: 'confirm-cancellation',
            content: "Are you sure you want to confirm cancellation? It will not be possible to return changes you've provided",
            okType: 'default',
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk() {
                hidePanel();
            }
        });
    }
    else {
        hidePanel()
    }
}